export default "__VITE_ASSET__DiduVmYA__"